import { useState } from "react";

import { IconButton, Tooltip } from "@mui/material";

import FileCopy from "@mui/icons-material/FileCopy";

const CopyToClipboardIcon = ({ text, color, disabled }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    return setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Tooltip title={isCopied ? "Copied!" : "Copy"}>
      <IconButton
        onClick={() => copyToClipboard()}
        style={{ color }}
        disabled={disabled}
      >
        <FileCopy />
      </IconButton>
    </Tooltip>
  );
};
export default CopyToClipboardIcon;
